import { render, staticRenderFns } from "./rodeDetail.vue?vue&type=template&id=358857e6&"
import script from "./rodeDetail.vue?vue&type=script&lang=js&"
export * from "./rodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./rodeDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rodeDetail.vue"
export default component.exports